module.exports = __webpack_public_path__ + "media/images/user/video_off_icon-5dcd3bc05beb5e642de9c09489ed59cd.png";